import api from './api';
import {
  DriverActivityResponse,
  DriverDashboardSummary,
  EarningsSummary,
  FleetSummary,
  ReferralSummary,
  SupportTicketPayload,
  WalletSummary,
} from '../types';

export const fetchDriverDashboardSummary = async (): Promise<DriverDashboardSummary> => {
  const response = await api.get('/api/driver/dashboard-summary');
  return response.data;
};

export const fetchDriverActivity = async (page = 1, limit = 30): Promise<DriverActivityResponse> => {
  const response = await api.get('/api/driver/activity', { params: { page, limit } });
  return response.data;
};

export const fetchDriverEarnings = async (): Promise<EarningsSummary> => {
  const response = await api.get('/api/driver/earnings');
  return response.data;
};

export const fetchDriverWallet = async (): Promise<WalletSummary> => {
  const response = await api.get('/api/driver/wallet');
  return response.data;
};

export const fetchDriverReferrals = async (): Promise<ReferralSummary> => {
  const response = await api.get('/api/driver/referrals');
  return response.data;
};

export const fetchDriverFleet = async (): Promise<FleetSummary> => {
  const response = await api.get('/api/driver/fleet');
  return response.data;
};

export const submitSupportTicket = async (payload: SupportTicketPayload) => {
  const response = await api.post('/api/driver/support', payload);
  return response.data;
};

export interface SupportTicket {
  id: string;
  category: string;
  subject: string;
  message?: string;
  status: 'open' | 'in_review' | 'resolved' | 'closed';
  priority: 'low' | 'normal' | 'high';
  adminResponse?: string | null;
  respondedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export const fetchSupportTickets = async (): Promise<SupportTicket[]> => {
  const response = await api.get('/api/driver/support-tickets');
  return response.data.tickets || [];
};
